import { AgGridColumnProps } from "ag-grid-react";
import * as React from "react";
import { localUserInfo } from "api";
import { InvoiceModel, GetInvoiceStatusAsText } from "api/invoice";
import { asCurrency, asDate, asTimelessDateUTC, GridView } from "lqx-react";

export interface InvoiceListProps {
  items: InvoiceModel[];
}

export const InvoiceGrid = ({ items }: InvoiceListProps) => (
  <GridView
    exportEvent="orders:export"
    items={items}
    columnDefs={invoiceColumns}
  />
);

function invoiceColumns(): AgGridColumnProps[] {
  const { isSupplier, isAdminRead } = localUserInfo;

  return [
    {
      headerName: "Status",
      field: "invoiceStatus",
      valueGetter: params => GetInvoiceStatusAsText(params.data.invoiceStatus)
    },

    ...(isSupplier || isAdminRead
      ? [{ headerName: "Distributor Name", field: "distributor.name" }]
      : []),

    ...(!isSupplier || isAdminRead
      ? [{ headerName: "Supplier Name", field: "supplier_name" }]
      : []),

    { headerName: "INV ID", field: "id" },
    { headerName: "INV #", field: "invoiceNumber" },
    { headerName: "PO #", field: "poNumber" },
    {
      headerName: "INV ANT",
      field: "invoicedAmount",
      cellStyle: { textAlign: "right" },
      valueFormatter: asCurrency
    },
    {
      headerName: "Invoice Date",
      field: "invoiceDueDateUtc",
      valueFormatter: asTimelessDateUTC
    },
    {
      headerName: "Creation Date",
      field: "invoiceCreatedDateUtc",
      valueFormatter: asTimelessDateUTC
    }
  ];
}
